import React from 'react';
import { css } from 'linaria';
import { SectionTitle } from 'common/components';
import { COMMON_LANDINGS_IMAGES_CDN_PATH } from 'common/constants/common';

const seasonStartHeader = css`
  width: 100%;
  @media (--from-desktop) {
    position: relative;
  }
`;

const seasonStartHeaderPattern = css`
  width: 112px;
  height: 68px;
  position: absolute;
  right: 0;
  top: 0;

  @media (--from-desktop) {
    top: -44px;
  }

  @media (--only-mobile) {
    width: 18%;
    height: unset;
  }
`;

type SeasonStartHeaderProps = {
  title: string;
}

export const SeasonStartHeader: React.FC<SeasonStartHeaderProps> = ({ title }) => (
  <div className={seasonStartHeader}>
    <SectionTitle size="extra">
      {title}
    </SectionTitle>
    <img
      alt="Желтые флажки"
      className={seasonStartHeaderPattern}
      src={`${COMMON_LANDINGS_IMAGES_CDN_PATH}/season-start/header/left-pattern.png/left-pattern-01.png`}
    />
  </div>
);
